export default {
  data() {
    return {
      article: {
        title: 'Its a title',
        scheduled_date: '2020-01-01',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt mi sed nisl vulputate gravida. Nam lobortis at mauris id vestibulum. Duis a odio purus. Aliquam dapibus vulputate finibus. Aliquam scelerisque suscipit felis, ut placerat urna. Praesent maximus viverra tortor in iaculis. Etiam scelerisque ex eros, vitae luctus mi venenatis nec. Integer aliquam, nibh in suscipit vestibulum, ex urna suscipit nisi, nec facilisis neque nibh at est. Maecenas tempus metus id elit eleifend, a congue urna iaculis. Nulla pulvinar ut metus at consequat. Nam sed ligula eget ex bibendum pretium ac vel risus. Donec sed porta tortor. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Maecenas faucibus felis eu pulvinar rutrum.\n',
          author: {
          name: 'John Doe',
          thumbnail: 'https://e7.pngegg.com/pngimages/8/36/png-clipart-man-black-illustration-computer-icons-google-account-user-profile-iconfinder-com-icons-profile-account-profile-thumbnail.png',
          slug: '#',
          email: true,
          facebook_url: true,
          instagram_url: true,
          twitter_url: true,
          linkedin_url: true,
          youtube_url: true,
          medium_url: true
        },
        categories: [
          {url: 1, name: 'Category 1'},
          {url: 2, name: 'Category 2'},
          {url: 3, name: 'Category 3'}
        ]
      },
      props: {
        'name': 'BlogPostComponent',
        'zIndex': 'auto',
        'paddingTop': '0px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
      },
      elements: [],
      internal_config: {
        'width': '1000px',
        'height': '500px',
        'zIndex': 'auto',
        'showDesktop': true,
        'showMobile': true,
        'paddingTop': '0px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
        left: '0px',
        top: '0px',
        show: {
          display: false,
          categories: true,
          author: true,
          date: true,
          formatDate: 'YYYY-MM-DD',
          shareBar: {
            display: true,
            email: true,
            copy: true,
            facebook: true,
            instagram: true,
            twitter: true,
            linkedin: true,
            youtube: true,
            medium: true,
            whatsapp: true,
            telegram: true,
            pinterest: true,
            align: 'left',
            theme: 'circle'
          }
        },
        colors: {
          color_1: 'white',
          color_2: '#000',
          color_3: '#fff',
          color_4: '#000',
          color_5: '#000'
        },
        styles: {
          title: {
            family: 'Lato, sans-serif',
            size: '25px',
            sizeMobile: '15px',
            color: 'black',
            align: 'left',
            weight: '400',
            style: 'initial',
            stroke: 'none'
          },
          author: {
            family: 'Lato, sans-serif',
            size: '25px',
            sizeMobile: '15px',
            color: 'black',
            align: 'left',
            weight: '400',
            style: 'initial',
            stroke: 'none'
          },
          categories: {
            family: 'Lato, sans-serif',
            size: '25px',
            sizeMobile: '15px',
            color: 'black',
            align: 'left',
            weight: '400',
            style: 'initial',
            stroke: 'none'
          }
        }
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/editor/apps/Blog/Post/Model.js